(() => {
  'use strict';
  document.documentElement.classList.remove('no-js');
  document.documentElement.classList.add('js');
  const initialiseHeader = (scope = document) => {
    scope.querySelectorAll('[data-eeco-header]').forEach((header) => {
      if (header.dataset.eecoReady === 'true') return;
      header.dataset.eecoReady = 'true';
      const panels = [...header.querySelectorAll('[data-header-panel]')];
      const closePanels = (restoreFocus = false) => {
        panels.forEach((panel) => {
          if (!panel.open) return;
          panel.open = false;
          if (restoreFocus) panel.querySelector('summary')?.focus();
        });
      };
      panels.forEach((panel) => {
        panel.addEventListener('toggle', () => {
          if (!panel.open) return;
          panels.forEach((other) => { if (other !== panel) other.open = false; });
        });
      });
      header.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        closePanels(true);
      });
      document.addEventListener('pointerdown', (event) => {
        if (!header.isConnected || header.contains(event.target)) return;
        closePanels();
      });
      const desktop = window.matchMedia('(min-width: 991px)');
      desktop.addEventListener('change', () => closePanels());
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialiseHeader(), { once: true });
  else initialiseHeader();
  document.addEventListener('shopify:section:load', (event) => initialiseHeader(event.target));
})();
